// import News from '@/components/News';
const News = dynamic(()=> import('@/components/News'))
import Layout from '@/components/Layout';
// const Layout = dynamic(()=> import('@/components/Layout'))
import dynamic from 'next/dynamic';
News.getLayout = function getLayout(page) {
    return (
        <Layout webViewMobile={true} web='news' >{page}</Layout>
    );
};


export async function getServerSideProps(context) {
    const UA = context.req.headers['user-agent'];
    try {
        const res = await fetch(`${process.env.NEXT_PUBLIC_API_SERVER_URL}/app/post/get-list-post`,
            {

                headers: {
                    'Content-Type': 'application/json',
                    locale: context.locale

                }
            });
        const data = await res.json();
        if (!data || data.code !== 200) {
            return {
                notFound: true,
            };
        }
        return {
            props: { ...data.data, sign: context.locale }, // will be passed to the page component as props
        };
    } catch (error) {
        console.log(error);
        return {
            notFound: true,
        };
    }

}

export default News;


